// extracted by mini-css-extract-plugin
export default {"row":"style_row__p+9yu","slide":"style_slide__Z-4Do"};